VLW.Compenents.CarteVinScrollBar = class extends VLW.classBase {
	constructor(elt) {
		super(elt);
		this.constructor.instance = this;
		
		this.isDragging           = false;
		this.myBar                = Draggable.create(this.elt.querySelector(".cursor"), {onDragEnd: () => this.isDragging = false,onDragStart: () => this.isDragging = true, onDrag: this.onDragBar, type: "x", bounds: this.elt})[0];
		this.elt.querySelector(".flecheLeft").addEventListener("click", this.onClickArrow);
		this.elt.querySelector(".flecheRight").addEventListener("click", this.onClickArrow);
		
		this.percent              = 0;
	}
	
	set percent(value) {
		this._percent = value;
		this._percent = Math.min(1, this.percent);
		this._percent = Math.max(0, this.percent);
		if(!this.isDragging) {
			TweenMax.to(this.myBar.target, .5, {force3D: false, x: this.myBar.maxX * this.percent});
		}
	}
	
	get percent() {
		return this._percent;
	}
	
	onDragBar(e) {
		VLW.Compenents.CarteVin.instance.zoomByScrollBar((this.myBar.x / this.myBar.maxX).toFixed(2));
	}
	
	onClickArrow(e) {
		this.percent += (e.currentTarget.classList.contains("flecheRight") ? 1 : -1) * .15;
		VLW.Compenents.CarteVin.instance.zoomByScrollBar(this.percent);
		TweenMax.set(this.myBar.target, {force3D: false, x: this.myBar.maxX * this.percent});
	}
	
	instanceClean() {
		this.myBar.kill();
		this.constructor.instance = null;
		this.elt.querySelector(".flecheLeft").removeEventListener("click", this.onClickArrow);
		this.elt.querySelector(".flecheRight").removeEventListener("click", this.onClickArrow);
		super.instanceClean();
	}
};
